import { select, call, put, all, takeLatest } from 'redux-saga/effects';
import selectWebsocket from './selectors';

import { SEND_TO_WS, FETCH_ARCHIVE_CLT_STATUS } from './constants';
import { uuidv4 } from '../../../config/utils/helpers';
import { archiveStatusFinished, cltStatusReceived } from './actions';
import axios from 'axios';
import { makeSelectLoginState } from '../App/selectors';
import { canSendWebsocketMessage } from '../../../config/utils/permissions_roles/roles';
import replayArchiveStatus from './archiveCltStatus';

function* sendToWsSaga(action) {
  const a = action;
  const state = yield select(selectWebsocket());
  const user = yield select(makeSelectLoginState());
  if (!canSendWebsocketMessage(user?.privilege, action.wsType)) return;
  try {
    state.websocket.websocketObject.send(
      JSON.stringify({
        type: a.wsType,
        timestamp: new Date().getTime(),
        sent: true,
        guid: uuidv4(),
        data: JSON.stringify(a.data),
        frontend: true,
        user,
        sessionUUID: a.sessionUUID
      })
    );
  } catch (error) {
    console.log('sendToWsSaga error', error);
  }
}

function* fetchOldStatusSaga(action) {
  if (action != undefined) {
    const apiCall = () => {
      return axios
        .post(`${window.location.origin}/api/v1/productionline/linestatus/get_data/`, {
          statusTime: action.statusTime,
          processIdentifier: action.processIdentifier,
          requireData: action.requireData,
          replayDiffs: action.replayDiffs
        })
        .then((response) => response.data)
        .catch((err) => {
          throw err;
        });
    };

    try {
      const response = yield call(apiCall);
      if (response.json !== undefined) {
        yield put(cltStatusReceived(replayArchiveStatus(response)));
      }
      yield put(archiveStatusFinished());
    } catch (error) {
      console.log(error);
      yield put(archiveStatusFinished());
    }
  }
}
export default function* cltStatusSaga() {
  yield all([yield takeLatest(SEND_TO_WS, sendToWsSaga), yield takeLatest(FETCH_ARCHIVE_CLT_STATUS, fetchOldStatusSaga)]);
}
